import { collection, addDoc, Timestamp } from "firebase/firestore";
import firebase from "../firebase/Config";

const userService = {
  async pushUserDetails(userDetails: any) {
    try {
        const userRef = collection(firebase.db, "UserDataUpload");
        const docRef = await addDoc(userRef, {
          ...userDetails,
          Timestamp: Timestamp.now(),
        }); 
      console.log("User data added with ID:", docRef.id);
      return docRef.id;
    } catch (error) {
      console.error("Error adding user: ", error);
      throw new Error("Error adding user");
    }
  },

  async pushFiles(userId: string, filename: string) {
    try {
        const fileRef = collection(firebase.db, `UserDataUpload/${userId}/Files`);
        const docRef = await addDoc(fileRef, {
          filename,
          Timestamp: Timestamp.now(),
        });
        console.log("File data added with ID:", docRef.id);
        return docRef.id;
    } catch (error) {
      console.error("Error adding user: ", error);
      throw new Error("Error adding user");
    }
  },
};

export default userService;
